import type { ReactNode } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function PanelDisclosure({
  title,
  children,
  defaultOpen = false,
  className,
}: {
  title: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? "panel" : undefined}
      className={className}
    >
      <AccordionItem value="panel" className="border-0">
        <AccordionTrigger className="gap-2 py-0 [overflow-wrap:anywhere]">
          {title}
        </AccordionTrigger>
        <AccordionContent className="pb-0 pt-3">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
